import React from 'react';
import './Article.css';

const Article = ({imgUrl, date, text}) => {
  return (
    <div className='blog-article-card'>
      <div className='blog-article-image'>
        <img src={imgUrl} alt="Blog-Image" />
      </div>
      <div className='blog-article-content'>
        <p className='blog-article-date'>{date}</p>
        <p className='blog-description'>{text}</p>
      </div>
      <p className='read-full-article'>Read Full Article</p>
    </div>
  )
}

export default Article
